import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Schoolpicnicspotnear() {



    const cardData =
    {
        keyword: 'School Picnic Spots Near Pune for Students Classes',
        heading: 'Anand Krushi Paryatan Kendra: School Picnic Spots Near Pune for Students Classes',
        headingDescription: 'When it comes to the best school picnic spots near Pune for students classes, Anand Krushi Paryatan Kendra in Morachi Chincholi stands out as a top destination. Located just 55 km from Pune, this 40-acre agri-tourism center is perfectly suited for students from pre-primary to higher secondary classes. The facility offers a variety of safe, interactive, and educational activities such as bullock cart rides, tractor rides, horse riding, boating, swimming, and rain dance. In addition, students enjoy entertaining magic shows, puppet performances, and traditional village games that encourage creativity and teamwork. With structured programs tailored for different age groups, Anand Krushi Paryatan Kendra provides a wholesome rural experience that blends learning with fun—making it an ideal spot for school picnics across all class levels.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




"services": [
  {
    "name": "Best Age-Wise Picnic Locations Near Pune",
    "description": "Carefully selected picnic spots categorized by age groups to ensure safety, accessibility, and engagement. Younger students enjoy calm, secure areas while older students get adventurous zones with educational challenges."
  },
  {
    "name": "Picnic Ideas by Class Group (1st–10th)",
    "description": "Customized picnic plans tailored to class-level interests and learning objectives, balancing play, education, and cultural exposure for each grade group."
  },
  {
    "name": "Safe Spots for Primary School Picnic",
    "description": "Fenced play areas with soft flooring, shaded rest zones, and supervised animal interaction sections provide a secure and nurturing environment for 1st to 5th graders."
  },
  {
    "name": "Nature Outings for High School Students",
    "description": "More challenging and in-depth outdoor experiences for grades 9 and 10 including nature walks, ecological projects, and science workshops designed to complement their academic curriculum."
  },
  {
    "name": "Activity-Focused Venues for Middle School",
    "description": "Zones designed for grades 6 to 8 featuring interactive farming activities, team-building games, and cultural workshops that foster leadership and curiosity."
  },
  {
    "name": "Group Play Areas for Children",
    "description": "Separate, age-appropriate play areas with equipment and games encouraging social skills, motor development, and teamwork for all class groups."
  },
  {
    "name": "Class-Wise Educational Farm Tours",
    "description": "Farm visits are structured differently for each class, from basic plant and animal care for younger students to deeper ecological studies and sustainability discussions for older groups."
  },
  {
    "name": "Interactive Learning Zones for Kids",
    "description": "Dedicated stations for hands-on science experiments, craft activities, and storytelling sessions tailored to the cognitive level of each age group."
  },
  {
    "name": "Tailored Games and Workshops by Age",
    "description": "Age-specific games such as nature scavenger hunts for younger kids and adventure problem-solving tasks for teenagers, complemented by workshops on ecology and culture."
  },
  {
    "name": "Fun & Science Combo Venues",
    "description": "Areas combining recreational activities with scientific exploration, like insect study walks, plant anatomy demonstrations, and mini-labs under supervision."
  },
  {
    "name": "Rural Life Education by Class Level",
    "description": "Students experience village life through cooking demos, craft-making, and traditional farming techniques tailored to their understanding and engagement level."
  },
  {
    "name": "Cultural Knowledge Picnics",
    "description": "Class-specific cultural programs featuring folk dances, local history storytelling, and craft workshops that build appreciation for Maharashtrian heritage."
  },
  {
    "name": "Student-Specific Programs at Farms",
    "description": "Personalized farm activities and learning modules aligned with students’ grade and interests, supported by trained educators ensuring active participation."
  },
  {
    "name": "Grade-Wise Group Picnic Suggestions",
    "description": "Recommendations for picnic itineraries and activity mixes suitable for each grade, helping teachers plan memorable and curriculum-aligned trips."
  }
],
"tableData": [
  ["Best Age-Wise Picnic Locations Near Pune", "Picnic Ideas by Class Group (1st–10th)"],
  ["Safe Spots for Primary School Picnic", "Nature Outings for High School Students"],
  ["Activity-Focused Venues for Middle School", "Group Play Areas for Children"],
  ["Class-Wise Educational Farm Tours", "Interactive Learning Zones for Kids"],
  ["Tailored Games and Workshops by Age", "Fun & Science Combo Venues"],
  ["Rural Life Education by Class Level", "Cultural Knowledge Picnics"],
  ["Student-Specific Programs at Farms", "Grade-Wise Group Picnic Suggestions"]
],



"whychoose": [
  {
    "WhyChooseheading": "Ideal Picnic Spot for All Student Classes Near Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra caters to students from various classes, offering customized activities that suit different age groups and learning levels, ensuring every student has an enriching and enjoyable experience."
  },
  {
    "WhyChooseheading": "Age-Appropriate Educational Activities",
    "WhyChoosedescription": "From interactive nature walks and simple farming activities for younger students to advanced ecological lessons and team-building exercises for older classes, the center designs programs that align with the curriculum and developmental needs of all students."
  },
  {
    "WhyChooseheading": "Safe and Supervised Environment",
    "WhyChoosedescription": "The center maintains strict safety protocols with trained staff to supervise all activities, making it a secure place for students of all ages to explore and learn without any concerns."
  },
  {
    "WhyChooseheading": "Diverse Outdoor and Indoor Facilities",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra offers a variety of facilities including open playgrounds, adventure zones, indoor classrooms for workshops, and quiet spots for cultural activities, suitable for diverse class requirements."
  },
  {
    "WhyChooseheading": "Nutritious Meals Tailored for Students",
    "WhyChoosedescription": "Understanding the dietary needs of growing students, the center provides wholesome and tasty meals prepared from fresh, organic farm produce, accommodating various dietary restrictions when needed."
  },
  {
    "WhyChooseheading": "Easily Accessible Location Near Pune",
    "WhyChoosedescription": "Situated just a comfortable distance from Pune, the center is ideal for day trips or overnight stays, reducing travel fatigue and allowing more time for learning and fun."
  }
]



































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the best school picnic spots near Pune for different student classes?',
    answer: 'Popular spots include Anand Krushi Paryatan Kendra, Morachi Chincholi, Ranjangaon Ganpati, Nighoj Kund, and Nisargshala. These locations offer safe, engaging, and educational experiences suitable for students from primary to higher secondary levels.',
  },
  {
    id: 'FAQ2',
    question: 'Which spots are suitable for primary school students?',
    answer: 'Places like Morachi Chincholi and Anand Krushi Paryatan Kendra are ideal for younger students due to their safe environments, fun rural games, animal interactions, and short travel times from Pune.',
  },
  {
    id: 'FAQ3',
    question: 'Are there spots that offer both learning and recreation for middle and high school students?',
    answer: 'Yes. Nighoj Kund offers geological insights, Ranjangaon Ganpati teaches cultural heritage, and Morachi Chincholi provides both agro-tourism and outdoor games – making them perfect for students in grades 6 to 10.',
  },
  {
    id: 'FAQ4',
    question: 'Are the picnic packages customizable for different age groups?',
    answer: 'Absolutely. Most picnic organizers tailor the activities, food, and supervision levels based on the students’ age groups and school preferences.',
  },
  {
    id: 'FAQ5',
    question: 'Do these spots provide educational value along with entertainment?',
    answer: 'Yes. The mix of temples, farms, biodiversity parks, and interactive rural activities ensures a blend of fun and learning suitable for all student classes.',
  },
  {
    id: 'FAQ6',
    question: 'Is safety ensured for all age groups during these picnics?',
    answer: 'All recommended spots are child-friendly with proper fencing, first aid, trained staff, and clear supervision – ensuring safety across age groups.',
  },
  {
    id: 'FAQ7',
    question: 'How far are these locations from Pune city?',
    answer: 'Most of these picnic spots are located within 40–80 km of Pune, easily reachable within 1.5 to 2 hours by school bus or private transport.',
  },
  {
    id: 'FAQ8',
    question: 'Do these picnic venues have facilities like washrooms and shaded areas?',
    answer: 'Yes, all locations include shaded seating areas, clean restrooms, and designated rest zones for students and teachers.',
  },
  {
    id: 'FAQ9',
    question: 'Is prior booking required for school groups?',
    answer: 'Yes, schools should book at least 2-3 weeks in advance to ensure availability and proper planning, especially during the school picnic season.',
  },
  {
    id: 'FAQ10',
    question: 'Can schools combine multiple spots in one picnic day?',
    answer: 'Yes, routes like Ranjangaon Ganpati – Nighoj Kund – Morachi Chincholi are designed to cover multiple spots in a single day, offering a mix of education and enjoyment.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Vaishali Apte, Principal, Pune',
    feedback: "We’ve taken students from Class 1 to 10 on different picnic routes. Anand Krushi and Morachi Chincholi are excellent for younger kids, while Nighoj and Ranjangaon add great educational value for older students.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Amit Gokhale, School Trip Coordinator, PCMC',
    feedback: "A perfect mix of education, nature, and fun. The picnic plans near Pune suit all class levels, and the students always come back with big smiles and new knowledge.",
    rating: 5,
  },
];






































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const schoolPicnicSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "School Picnic Spots Near Pune for Students Classes",
  "description": "Find the best class-wise school picnic spots near Pune. Ideal for grades 1st to 10th, including primary school picnics, interactive farm learning, nature activities, cultural workshops, and age-appropriate games.",
  "educationalProgramMode": "OnSite",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Primary School Picnic Activities",
      "description": "Safe play zones, bird watching, and basic nature walks designed for classes 1st to 4th."
    },
    {
      "@type": "Course",
      "name": "Middle School Agro-Tourism",
      "description": "Farm games, bullock cart rides, and interactive farming demos for classes 5th to 7th."
    },
    {
      "@type": "Course",
      "name": "High School Cultural & Environmental Learning",
      "description": "Eco-education trails, cultural sessions, and group workshops for classes 8th to 10th."
    }
  ],
  "url": "https://morachichincholi.in/school-picnic-by-class-near-pune"
};




    return (
        <div>
<Helmet>
  <title>School Picnic Spots Near Pune by Class | Age-Wise Educational Trips | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Plan age-specific school picnics near Pune for classes 1st to 10th. Safe, fun, and educational spots with nature games, farming activities, and cultural exposure. Perfect for group outings by grade." 
  />
  <meta 
    name="keywords" 
    content="Best age-wise picnic locations near Pune, Picnic ideas by class group, Safe spots for primary school picnic, Nature outings for high school students, Activity-focused venues for middle school, Class-wise educational farm tours, Tailored games and workshops by age, Cultural knowledge picnics, Rural life education by class level, Group play areas for children, Student-specific programs at farms, Grade-wise group picnic suggestions" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnicSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Schoolpicnicspotnear;